import { useState, useEffect } from 'react';
import { getTechniqueMastery } from '@services/repService';

/** The authenticated learner's mastery_score per technique they've
 * touched (technique_mastery, updated on every rep run — see
 * techniqueMasteryService.js). Untouched techniques simply have no row
 * here; callers should treat that as 0, not omit the technique. */
export const useTechniqueMastery = () => {
  const [mastery, setMastery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTechniqueMastery()
      .then(data => { if (!cancelled) setMastery(data); })
      .catch(() => { if (!cancelled) setMastery([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { mastery, loading };
};

export default useTechniqueMastery;
